import React from 'react';
import { motion } from 'framer-motion';
import { PageShell } from '../components/PageShell';
import { SectionHeading } from '../components/SectionHeading';
import { capabilityGroups, systemsPortfolio } from '../data/profile';
export function TechnicalMastery() {
  return <PageShell path="/technical" data-id="element-394" data-mp="15mc72flydhq1">
      <section id="mastery" className="bg-white py-20 lg:py-24" aria-labelledby="mastery-heading" data-id="element-395" data-mp="15m2ove75geuw">
        <div className="mx-auto w-full max-w-7xl px-6 lg:px-10" data-id="element-396" data-mp="1jlbyfv0uoapw">
          <div id="mastery-heading" data-id="element-397" data-mp="1en0kb83ive1v">
            <SectionHeading eyebrow="Technical Mastery" title="Frameworks, tooling and engineering foundations" description="The standards and platforms she has implemented, governed and been accountable for at enterprise scale." data-id="element-398" data-mp="1elzb7962h1ms" />
          </div>

          <div className="mt-12 grid grid-cols-1 gap-8 lg:grid-cols-3" data-id="element-399" data-mp="22dmsr0hfv0ce">
            {capabilityGroups.map((group, index) => <motion.article key={group.title} initial={{
            opacity: 0,
            y: 14
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.3
          }} transition={{
            duration: 0.28,
            delay: index * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col border border-platinum-200 bg-white p-8" data-id="element-400" data-mp="1ycuiq50qsrf2" data-mpi={index}>
                <h3 className="font-display text-lg font-bold tracking-tight text-navy-900" data-id="element-401" data-mp="2al3dghm4g34">
                  {group.title}
                </h3>
                <p className="mt-3 font-sans text-sm leading-relaxed text-charcoal-600" data-id="element-402" data-mp="bcucq315a3ex">
                  {group.description}
                </p>
                <ul className="mt-auto flex flex-wrap gap-2 pt-7" data-id="element-403" data-mp="g6fdg2u4hbht">
                  {group.items.map(item => <li key={item} className="whitespace-nowrap border border-platinum-300 bg-platinum-100 px-3 py-1.5 font-sans text-xs font-semibold text-charcoal-700" data-id="element-404" data-mp="q2igdawste5t">
                      {item}
                    </li>)}
                </ul>
              </motion.article>)}
          </div>
        </div>
      </section>

      <section id="portfolio" className="bg-navy-900 py-20 lg:py-24" aria-labelledby="portfolio-heading" data-id="element-405" data-mp="f3sovlmt3p41">
        <div className="mx-auto w-full max-w-7xl px-6 lg:px-10" data-id="element-406" data-mp="acamqu91rihh">
          <div id="portfolio-heading" data-id="element-407" data-mp="aapqn0733rhi">
            <SectionHeading eyebrow="Systems Portfolio" title="The governed architecture she has stood up" description="A federated reference model, read from the business domain down to the AI control plane." tone="dark" data-id="element-408" data-mp="o35we8rde3m4" />
          </div>

          <ol className="mt-12 border-t border-white/10" data-id="element-409" data-mp="t43hat3rlbrb">
            {systemsPortfolio.map((layer, index) => <li key={layer.layer} className="grid grid-cols-1 gap-4 border-b border-white/10 py-7 lg:grid-cols-12 lg:gap-12" data-id="element-410" data-mp="2zu1jp9tlnp84" data-mpi={index}>
                <div className="flex items-baseline gap-4 lg:col-span-4" data-id="element-411" data-mp="1adfg6ck6o69y">
                  <span className="font-display text-sm font-bold text-gold-500" data-id="element-412" data-mp="1fb7im0igfase">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <h3 className="font-display text-lg font-bold leading-snug text-white" data-id="element-413" data-mp="10kgryvslmhqv">
                    {layer.layer}
                  </h3>
                </div>
                <p className="font-sans text-base leading-relaxed text-platinum-300 lg:col-span-8" data-id="element-414" data-mp="rl3g5wh05h2z">
                  {layer.detail}
                </p>
              </li>)}
          </ol>
        </div>
      </section>
    </PageShell>;
}